import dynamic from 'next/dynamic';

import SkeletonLoader from '@components/atoms/SkeletonLoader';

const DeliveryTime = dynamic(() => import('./DeliveryTime'), {
  ssr: false,
  loading: () => <SkeletonLoader iconWidth={125} background="white" />,
});

export default DeliveryTime;
